import React, { useEffect } from 'react';

import {
  useResetAccountPasswordState,
  useResetAccountPasswordActions
} from './ResetAccountPasswordContext';

import { resetCurrentAccountPassword } from './restApi';

import Form from '../../Shared/UI/Form/components/Form';
import Field from '../../Shared/UI/Field/components/Field';
import Input from '../../Shared/UI/Input/components/Input';
import Button from '../../Shared/UI/Button/components/Button';

const ResetAccountPasswordContent = () => {
  const state = useResetAccountPasswordState();
  const { initializeState, onResponse, onError, updateResetAccountPasswordFormPassword, updateResetAccountPasswordFormPasswordConfirmation } = useResetAccountPasswordActions();

  useEffect(() => {
    initializeState();
  }, []);

  const handleSubmit = () => {
    resetCurrentAccountPassword({
      onResponse,
      onError,
      body: {
        passwordResetTokenId: state?.passwordResetTokenId,
        passwordResetTokenValue: state?.passwordResetTokenValue,
        newPassword: state?.resetAccountPasswordForm?.password,
        newPasswordConfirmation: state?.resetAccountPasswordForm?.passwordConfirmation,
        authenticityToken: document.querySelector("meta[name='csrf-token']").getAttribute("content")
      },
    });
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Field label="New Password" id="new_password">
        <Input
          type="password"
          name="account[password]"
          value={state?.resetAccountPasswordForm?.password}
          onChange={(e) => updateResetAccountPasswordFormPassword(e.target.value)}
        />
      </Field>

      <Field label="New Password confirmation" id="new_password_confirmation">
        <Input
          type="password"
          name="account[password_confirmation]"
          value={state?.resetAccountPasswordForm?.passwordConfirmation}
          onChange={(e) => updateResetAccountPasswordFormPasswordConfirmation(e.target.value)}
        />
      </Field>

      <Button type="submit">
        Reset Password
      </Button>
    </Form>
  );
};

export default function ResetAccountPassword() {
  return (
    <ResetAccountPasswordContent />
  );
}
